/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PopupCampaignPlatform {
    IOS = 'Ios',
    ANDROID = 'Android',
    WEB_MOBILE = 'WebMobile',
    WEB_DESKTOP = 'WebDesktop',
}
